<template>
    <button ref="filterDropdown" @click="toggleDropDown"
        class="relative w-auto whitespace-nowrap px-4 flex items-center gap-1 justify-center py-1.5 text-sm rounded-md border border-solid border-gp-grey-70">
        <IconSort></IconSort>
        <div>{{ currentValue?.name[$i18n.locale] }}</div>
        <ul v-if="dropDown === true"
            class="absolute top-10 z-50 bg-white mt-1 w-52 flex flex-col item-center justify-center rounded border border-solid border-gp-grey-70 divide-y divide-solid divide-gp-grey-70">
            <li v-for="(el, idx) in options" :key="idx">
                <button @click="onSelect(el)"
                    class="px-5 w-full text-start text-sm py-1.5">{{  el?.name[$i18n.locale]
                    }}</button>
            </li>
        </ul>
    </button>
</template>

<script setup>
import IconSort from '@icons/IconSort.vue';
import { ref } from 'vue'
import { onClickOutside } from '@vueuse/core'
import { i18n } from '@/i18n'
const filterDropdown = ref()
const dropDown = ref(false)
const currentValue = ref()

const props = defineProps({
    options: {
        type: Array,
        default: []
    },
    defaultValue: {
        
    }
})

currentValue.value = props.defaultValue

const emit = defineEmits(['on-select'])
const onSelect = (selected) => {
    emit('on-select', selected.value)
    currentValue.value = selected

}

onClickOutside(filterDropdown, () => dropDown.value = false)

const toggleDropDown = () => {
    dropDown.value = !dropDown.value
}

</script>